// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-47dbdb26] {\n  max-height: 70%;\n}\n.logo-title[data-v-47dbdb26] {\n  color: #fff;\n  padding-left: 0.3rem;\n}\n.logout[data-v-47dbdb26] {\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
